import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { ShareForm, CreateMessage, AddTask, TextMessage, CreateDocument, FolderStructure, CreateEvent, SendEmail } from './actions';
import { actionCodes } from 'constants/automation';

export default function DynamicActionCards({ index }) {
  const { control } = useFormContext();

  const selectedAction = useWatch({
    control: control,
    name: `actions[${index}].action_code`,
  });

  return (
    <div>
      {selectedAction === actionCodes.ACT_SHARE_FORM && <ShareForm index={index} />}
      {selectedAction === actionCodes.ACT_SEND_SECURE_MESSAGE && <CreateMessage index={index} />}
      {selectedAction === actionCodes.ACT_TASK_CREATE && <AddTask index={index} />}
      {selectedAction === actionCodes.ACT_SEND_TEXT_MESSAGE && <TextMessage index={index} />}
      {selectedAction === actionCodes.ACT_CREATE_DOCUMENT && <CreateDocument index={index} />}
      {selectedAction === actionCodes.ACT_BULK_UPLOAD_FOLDER && <FolderStructure index={index} />}
      {selectedAction === actionCodes.ACT_EVENT_CREATE && <CreateEvent index={index} />}
      {selectedAction === actionCodes.ACT_SEND_EMAIL && <SendEmail index={index} />}
    </div>
  );
}
